import { render, staticRenderFns } from "./MindmapPlaySetupModal.vue?vue&type=template&id=386167e3&scoped=true"
import script from "./MindmapPlaySetupModal.vue?vue&type=script&lang=js"
export * from "./MindmapPlaySetupModal.vue?vue&type=script&lang=js"
import style0 from "./MindmapPlaySetupModal.vue?vue&type=style&index=0&id=386167e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386167e3",
  null
  
)

export default component.exports